import React from 'react';
import { LogoLoading } from '@/shared/ui/custom/logo-loading';

interface PDFLoadingStateProps {
  message?: string;
}

export const PDFLoadingState: React.FC<PDFLoadingStateProps> = ({ message = 'Loading PDF...' }) => {
  return (
    <div className="flex items-center justify-center w-full h-full bg-muted/50">
      <LogoLoading variant="breathing" size="lg" message={message} />
    </div>
  );
};
